import React from 'react';
import {BillingState} from 'app/components/BillingManager/types/types';

export const BillingManagerContext = React.createContext<BillingState | undefined>(undefined);
